import React from 'react';
import OnepageHeader from '../../components/Layout/Header/OnepageHeader';
import Footer from '../../components/Layout/Footer';
import HomeThreeOnepageMain from './HomeThreeOnepageMain';

const HomeThreeOnePage = () => {
    return (
        <React.Fragment>
            <OnepageHeader/>
            <HomeThreeOnepageMain />
            <Footer footerClass="rs-footer" />
        </React.Fragment>
    );
}

export default HomeThreeOnePage;
